export default __webpack_public_path__ + "static/media/tracy2.b295c109.jpeg";